// extracted by mini-css-extract-plugin
export default {"container":"extra_container__btEjT","comp":"extra_comp__BrQma","text":"extra_text__QyTPd","pic":"extra_pic__WVrA6","off":"extra_off__ueN5z","off2":"extra_off2__6kmv+"};